/**
 * The legal identity behind Agentic School: ONE source for the imprint, the
 * privacy policy, the terms, Organization JSON-LD and every email footer.
 * Pure data, no imports, so Convex (emails) and the web app share it.
 *
 * Moving, renaming or registering the business = editing this file only.
 */
import type { Locale } from './i18n/config'

export const COMPANY = {
  /** Public brand. */
  brand: 'Agentic School',
  /** Legal provider (sole proprietorship, not in the commercial register). */
  legalName: 'Nico Jaroszewski',
  /** First name the founder signs emails with. */
  founderFirstName: 'Nico',
  street: 'Schlosstalstrasse 202',
  postalCode: '8408',
  city: 'Winterthur',
  countryCode: 'CH',
  country: {
    en: 'Switzerland',
    de: 'Schweiz',
    fr: 'Suisse',
    it: 'Svizzera',
  } satisfies Record<Locale, string>,
  /** General + privacy contact. */
  email: 'info@agenticschool.dev',
  website: 'https://agenticschool.dev',
  /** Place of jurisdiction named in the terms. */
  jurisdiction: 'Winterthur',
} as const

/** "Schlosstalstrasse 202, 8408 Winterthur, Switzerland" in the given locale. */
export function companyAddress(locale: Locale): string {
  return `${COMPANY.street}, ${COMPANY.postalCode} ${COMPANY.city}, ${COMPANY.country[locale]}`
}

/** "Nico Jaroszewski, Schlosstalstrasse 202, ..." (provider + address). */
export function companyLegalLine(locale: Locale): string {
  return `${COMPANY.legalName}, ${companyAddress(locale)}`
}
